import React, { Component } from "react";
import { Modal } from "antd";
import Webcam from "react-webcam";

const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user",
};

export default class UploadImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_camera: false,
      imageSrc: "",
    };
  }

  handleOk = (e) => {
    console.log(e);
    this.openCamera(false);
  };

  handleCancel = (e) => {
    console.log(e);
    this.openCamera(false);
  };

  openCamera = (status) => {
    this.setState({
      show_camera: status,
    });
  };

  fileSelectedHandler = (event) => {
  console.log(event.target.files[0]);
  this.setState({
      selectedFile: event.target.files[0]
  }, () => this.fileUploadHandler());
};
  setRef = (webcam) => {
    this.webcam = webcam;
  };

  capture = () => {
    //console.log("Clicking");
    //console.log(this.webcam.getScreenshot());
    this.setState({
      imageSrc: this.webcam.getScreenshot(),
    });
  };

  retake = () => {
    this.setState({
      imageSrc: "",
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="multiple-file-upload-container">
          <div className="top-part">
            <div className="file-upload-container">
              <div className="title">Upload File</div>
              <label htmlFor="myInput">
                {/* <i class="fa fa-cloud-upload" htmlFor="myInput"></i> */}
                <span htmlFor="myInput" className="upload_icon">
                   <svg width="367" height="483" viewBox="0 0 367 483" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M190.534 162.955C186.61 159.015 180.227 159.015 176.287 162.955L119.96 219.29C117.06 222.183 116.21 226.517 117.769 230.267C119.345 234.034 123.002 236.492 127.068 236.492H151.702V309.55C151.702 316.965 157.707 322.97 165.099 322.97H201.725C209.132 322.97 215.136 316.965 215.136 309.55V236.492H239.77C243.837 236.492 247.508 234.034 249.085 230.267C250.63 226.517 249.777 222.182 246.894 219.29L190.534 162.955Z" fill="black"/>
<path d="M244.946 0H51.315C23.009 0 0 23.025 0 51.315V430.824C0 459.113 23.009 482.139 51.315 482.139H315.519C343.794 482.139 366.835 459.113 366.835 430.824V121.449L244.946 0ZM315.519 450.698H51.315C40.345 450.698 31.424 441.793 31.424 430.824V51.315C31.424 40.362 40.345 31.457 51.315 31.457L233.189 31.268V98.486C233.189 118.139 249.138 134.089 268.776 134.089L334.654 133.9L335.379 430.825C335.379 441.793 326.49 450.698 315.519 450.698Z" fill="black"/>
</svg>

                </span>
              </label>
             
              <input type="file" id="myInput" onChange={this.fileSelectedHandler} />
            </div>
            <div className="camera-button-container">
              <div className="title">Open Camera</div>
              <button className="button" onClick={() => this.openCamera(true)}>
                
                  <svg width="367" height="483" viewBox="0 0 367 483" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M244.946 0H51.315C23.009 0 0 23.025 0 51.315V430.824C0 459.113 23.009 482.139 51.315 482.139H315.519C343.794 482.139 366.835 459.113 366.835 430.824V121.449L244.946 0ZM315.519 450.698H51.315C40.345 450.698 31.424 441.793 31.424 430.824V51.315C31.424 40.362 40.345 31.457 51.315 31.457L233.189 31.268V98.486C233.189 118.139 249.138 134.089 268.776 134.089L334.654 133.9L335.379 430.825C335.379 441.793 326.49 450.698 315.519 450.698Z" fill="black"/>
<path d="M204.288 249.647C204.288 261.385 194.739 270.935 183 270.935C171.261 270.935 161.715 261.385 161.715 249.647C161.715 237.908 171.261 228.358 183 228.358C194.739 228.358 204.288 237.911 204.288 249.647ZM249 219.418V279.882C249 287.943 242.465 294.479 234.404 294.479H131.596C123.535 294.479 117 287.943 117 279.882V219.418C117 211.357 123.535 204.822 131.596 204.822H149.549V199.772C149.549 192.718 155.264 187 162.321 187H203.679C210.736 187 216.451 192.718 216.451 199.772V204.818H234.404C242.465 204.822 249 211.357 249 219.418ZM215.236 249.647C215.236 231.872 200.774 217.411 183 217.411C165.229 217.411 150.768 231.872 150.768 249.647C150.768 267.421 165.229 281.882 183 281.882C200.774 281.882 215.236 267.421 215.236 249.647Z" fill="black"/>
</svg>

               
              </button>
            </div>
          </div>
          {/* Camera Modal */}
          <Modal title="Say Cheese!!!" visible={this.state.show_camera} onOk={this.handleOk} onCancel={this.handleCancel}>
            <div className="camera-container">
              {this.state.imageSrc === "" && this.state.show_camera ? (
                <Webcam
                  className={this.state.imageSrc !== "" ? "hide-element" : ""}
                  audio={false}
                  height={350}
                  ref={this.setRef}
                  screenshotFormat="image/jpeg"
                  width={350}
                  videoConstraints={videoConstraints}
                />
              ) : (
                <img alt="" className={"camera-preview-image " + (this.state.imageSrc !== "" ? "" : "hide-element")} src={this.state.imageSrc} />
              )}
            </div>

            <center>
              <button className={"submit-button " + (this.state.imageSrc !== "" ? "hide-element" : "")} onClick={this.capture}>
                Capture photo
              </button>
            </center>
            <center>
              <button className={"cancel-button " + (this.state.imageSrc !== "" ? "" : "hide-element")} onClick={this.retake}>
                Retake
              </button>
            </center>
          </Modal>
          {/* Camera Modal ends */}
          {this.props.data.map((data, index) => (
            <div className="bottom-part">
              <div className="pdf-file-container">
                <div className="pdf-file-image-container">
                  <i alt="" className="fa fa-picture-o" />
                </div>
                <div className="pdf-file-name">{data.filename}</div>
              </div>
              <div className="pdf-file-preview-container">
                <div className="pdf-file-delete">
                  <i className="fa fa-trash" />
                </div>
                <button className="preview-button">
                  <i className="fa fa-eye" />
                  Preview
                </button>
              </div>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}
